<template>
  <section 
    class="rhyme-settings py-1" 
    :class="{'bg-white' : showRhymeSettings, 'mobile-rhyme-options' : mobile}"  v-hotkey="keymap">
    <div 
      class="d-flex justify-content-between px-2 position-relative"
      style="cursor:pointer"
      @click="toggleRhymeSettings"
      v-if="!mobile"
     >
      <h3 
        class="m-0" 
        :class="{'text-primary' : showRhymeSettings}">
        {{hebrew ? 'חרוזים' : 'Rhymes'}}
        <small 
          style="font-size:7px;top:-3px;" 
          class="position-relative"
          v-if="rhymeSettingChanges">
            <i class="text-primary fas fa-circle"></i>
        </small>
      </h3>
      <i v-if="showRhymeSettings" class="fas fa-sort-up text-primary" style="margin-top:6px;"></i>
      <i v-if="!showRhymeSettings"  class="fas fa-sort-down" ></i>
    </div>    
    <div 
      class="advanced-rhyme-options settings-wrap px-lg-2 pt-2"      
      v-if="showRhymeSettings || mobile">
      <small class="mb-1">{{hebrew ? 'רמת דיוק' : 'Precision'}}</small>
      <b-form-checkbox 
        id="rhyme-option" 
        ref="rhymeModeCb"
        :class="{'mobile-rhyme-mode' : mobile}" 
        v-model="rhymeMode" 
        value="half" 
        unchecked-value="full">
          {{hebrew ? 'כלול חרוזי ״שור וחמור״' : 'Include ...'}} 
          <span id="consonant-popover" v-if="!mobile"><i class="fa fa-info-circle"></i></span>
      </b-form-checkbox>
      <b-popover target="consonant-popover" container="" placement="top" triggers="hover focus">
        <p class="mb-1">
          אם אפשרות זאת מופעלת, אז התוצאות כוללות גם מילים שאינן זהות בהברה האחרונה כולה, אלא רק בתנועה האחרונה (ובעיצור סופי, אם יש). 
          <br>
          דוגמאות: שׁוֹר - חֲמוֹר ; מִשְׁפָּחָה - אַבְחָנָה.
        </p>
        <p class="mb-0">
אם אפשרות זאת איננה מופעלת, אז התוצאות כוללות רק מילים שזהות בהברה האחרונה באופן מלא.
        <br>
        דוגמאות: שׁוֹר - מִישׁוֹר; מִשְׁפָּחָה - צְוָחָה.
        </p>
      </b-popover>      
      <LetSwapOption v-if="!mobile" />
      <TextStyle />
      <AccentSettings />
    </div>      
  </section>
</template>
<script>
  import {BlankState, Actions} from '@/store/stateChanges'
  import LetSwapOption from '@/components/letSwapOption'
  import AccentSettings from '@/components/AccentSettings'
  import TextStyle from '@/components/TextStyle'

  export default  {
    name: 'RhymeSettings',
    components: {LetSwapOption, AccentSettings, TextStyle},
    data() {
      return {
        showRhymeSettings: false        
      }
    },     
    methods: {
      onModeKeyPress() {
        this.showRhymeSettings = true
        document.activeElement.blur()
        if (this.rhymeMode === 'half')
          this.$store.commit('SET_RHYME_MODE',  'full')
        else    
          this.$store.commit('SET_RHYME_MODE',  'half')
        if (!this.mobile)     
          this.$store.dispatch(Actions.RUN_CHARUZIT)        
      },            
      toggleRhymeSettings () {
        this.showRhymeSettings = !this.showRhymeSettings        
      }          
    },
    computed: {
      keymap () {
        return {
          'shift+/': () => {
            this.onModeKeyPress()
          }
        }
      },
      rhymeMode: {
        get () {
          return this.$store.state.preSubmissionOptions.rhymeMode
        },  
        set (value) {
          this.$store.commit('SET_RHYME_MODE',  value)
          if (this.mobile) {
            this.$store.commit("SET_LET_SWAP", this.rhymeMode === 'half')
            this.$store.commit("SET_VOC_SWAP", this.rhymeMode === 'half')
          }
           if (!this.mobile)    
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }
      },   
      hebrew () {
        return this.$settings.hebrew    
      },
      mobile () {
        return this.$mq === 'xs'
      },
      rhymeSettingChanges () {
        return JSON.stringify(BlankState.preSubmissionOptions.LetSwapSettings) !==  JSON.stringify(this.$store.state.preSubmissionOptions.LetSwapSettings)
        || BlankState.preSubmissionOptions.rhymeMode !== this.$store.state.preSubmissionOptions.rhymeMode
        || BlankState.preSubmissionOptions.accent !== this.$store.state.preSubmissionOptions.accent
        || BlankState.preSubmissionOptions.includeForeign !== this.$store.state.preSubmissionOptions.includeForeign
        || BlankState.preSubmissionOptions.includeNonBase !== this.$store.state.preSubmissionOptions.includeNonBase
      },    
    }
  }
</script>
<style  lang="scss">
  .rhyme-settings {
    border-top:1px solid #c8c8c8;    
  }
  .mobile-rhyme-options {
    margin-top: 25px;
    small {
      font-size: 18px;
    }
  }
  .mobile-rhyme-mode {
    margin-top: 5px;
    padding: 18px 14px!important;
    box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.3);
    border: 1px solid #c8c8c8;
    border-radius: 2px;
    min-height: 64px;
    font-size: 18px;
    &.custom-checkbox .custom-control-label {
      display: block;
    }
    &.custom-checkbox .custom-control-label:after,
    &.custom-checkbox .custom-control-label:before {
      left: 0;
      right: auto;
      top: 1px;
      height: 24px;
      width: 24px;
    }
  }
</style>